/* --------------------------------------------------------------------------------------

Add the following classes to the according elements:
  mask containing the slides:   .js_slider_mask
  slides in the mask:           .js_slider_slide
  previous slide button:        .js_slider_prev
  next slide button:            .js_slider_next

options: {
  wrapper: object // DOM Element
}

-------------------------------------------------------------------------------------- */

class Slider {
  constructor(options) {
    this.wrapper = options.wrapper;
    this.mask = this.wrapper.querySelector('.js_slider_mask');
    this.slides = this.mask.querySelectorAll('.js_slider_slide');
    this.prev = this.wrapper.querySelector('.js_slider_prev');
    this.next = this.wrapper.querySelector('.js_slider_next');
    this.enableDisable = this.enableDisable.bind(this);
    this.showSlide = this.showSlide.bind(this);
    this.showPrevSlide = this.showPrevSlide.bind(this);
    this.showNextSlide = this.showNextSlide.bind(this);
    window.addEventListener('resize', this.enableDisable);
    this.prev.addEventListener('click', this.showPrevSlide);
    this.next.addEventListener('click', this.showNextSlide);
    this.enableDisable();
  }
  enableDisable() {
    const clientWidth = this.mask.clientWidth;
    const scrollWidth = this.mask.scrollWidth;
    if (clientWidth < scrollWidth) {
      const gap = parseInt(window.getComputedStyle(this.mask).getPropertyValue("gap"));
      this.slideWidth = this.slides[0].clientWidth + gap;
      this.step = Math.floor((clientWidth + gap) / this.slideWidth);
      this.showSlide(0);
    } else {
      this.mask.style.transform = '';
      this.slides.forEach(elem => elem.classList.add('visible'));
      this.prev.disabled = true;
      this.next.disabled = true;
    }
  }
  showSlide(i) {
    i = i < 0 ? 0 : i >= this.slides.length - 1 ? this.slides.length - 1 : i;
    this.activeSlide = i;
    this.mask.style.transform = 'translateX(' + -i * this.slideWidth + 'px)';
    this.slides.forEach(elem => elem.classList.remove('visible'));
    for (let j = i; j < Math.min(i + this.step, this.slides.length); j++) {
      this.slides[j].classList.add('visible');
    }
    this.prev.disabled = i == 0 ? true : false;
    this.next.disabled = i == this.slides.length - 1 ? true : false;
  }
  showPrevSlide() {
    this.showSlide(this.activeSlide - this.step);
  }
  showNextSlide() {
    this.showSlide(this.activeSlide + this.step);
  }
}